import { useState } from "react"
import { Button } from "../../../components/Button";
import { SignedUrlImage } from "../../../components/SignedUrlImage";
import { useApp } from "../../../services/app-context";

function BulletPoint({ text, number, title }: { text: string; title: string; number: number }) {
    return (
        <div className="flex flex-col gap-2">
            <div className="text-sm font-medium text-text-primary">{number}. {title}</div>
            <div className="text-text-primary text-xs font-normal opacity-60">{text}</div>
        </div>
    )
}


export function Step3({ onContinue }: { onContinue: () => void }) {
    const {tenantProfile} = useApp()
    return (

        <div className="flex items-center gap-10 pb-10 pt-8 pl-10 pr-5">
            <div className="flex-[2] flex justify-center">
                <SignedUrlImage s3Key="onboarding-3.svg" bucket={tenantProfile?.assets_bucket} alt="logo" className="w-[152px] h-[152px]" />
            </div>
            <div className="flex flex-col gap-4 flex-[3]">
                <div>
                    <div className="flex flex-col gap-2">
                        <span className="text-black text-[21px] font-bold ">Here's how PraxisPro works:</span>
                    </div>
                    <div className="flex flex-col gap-[18px] mt-6">
                        <BulletPoint title="Choose an AI HCP" number={1} text="Expectations, questions, and conversations will vary depending on the role" />
                        <BulletPoint title="Engage in conversation" number={2} text="You'll have 2 - 10 minutes to engage in roleplay." />
                        <BulletPoint title="View your feedback report" number={3} text="You'll see your session score, your strengths and improvement opportunities for your next session." />
                    </div>
                    <div className="mt-10 flex justify-end">
                        <Button variant="primary" className="!rounded-full w-[136px] !h-[38px]" onClick={onContinue}>Continue</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}